export default __webpack_public_path__ + "static/media/login-rght.6194be38.png";